import { useEffect, useState } from "react";
import ChangePIN from "./ChangePIN";

const STATIC_OTP = "1234";

const Getotp = () => {
  const [otp, setOTP] = useState("");
  const [valid, setValid] = useState(0);
  const [error, setError] = useState("");

  const submitHandler = (e) => {
    e.preventDefault();
    setError("");
    if (otp === STATIC_OTP) {
      setValid(1);
    } else {
      setError("Invalid OTP. Please enter the correct 4-digit code.");
    }
    setOTP("");
  };

  useEffect(() => {
    const obj = document.getElementById("otp-input");
    if (!obj) return;
    obj.addEventListener("keydown", stopCarret);
    obj.addEventListener("keyup", stopCarret);

    function stopCarret() {
      if (obj.value.length > 3) {
        setCaretPosition(obj, 3);
      }
    }

    function setCaretPosition(elem, caretPos) {
      if (elem != null) {
        if (elem.createTextRange) {
          var range = elem.createTextRange();
          range.move("character", caretPos);
          range.select();
        } else {
          if (elem.selectionStart) {
            elem.focus();
            elem.setSelectionRange(caretPos, caretPos);
          } else elem.focus();
        }
      }
    }
    // Cleanup
    return () => {
      obj.removeEventListener("keydown", stopCarret);
      obj.removeEventListener("keyup", stopCarret);
    };
  }, []);

  return valid ? (
    <ChangePIN />
  ) : (
    <div className="otpform">
      <h2>Verify OTP</h2>
      <p className="instructions">
        Please enter the 4-digit One Time Password (OTP) sent to your registered email or phone number.<br />
        <b>For demo purposes, use <span style={{color: '#667eea'}}>1234</span> as the OTP.</b>
      </p>
      <form name="OTP" onSubmit={submitHandler} autoComplete="off">
        <div className="form-group">
          <label htmlFor="otp-input" className="highlight-label">Enter OTP</label>
          <input
            type="text"
            id="otp-input"
            autoComplete="off"
            maxLength="4"
            name="otp"
            value={otp}
            onChange={(e) => setOTP(e.target.value.replace(/\D/g, ""))}
            required
            pattern="\d{4}"
            placeholder="4-digit OTP"
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button className="subButton" type="submit" disabled={otp.length !== 4}>
          Proceed
        </button>
      </form>
    </div>
  );
};

export default Getotp;